function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { stateGo } from 'redux-ui-router';
import __ from 'ramda/src/__';
import equals from 'ramda/src/equals';
import pathOr from 'ramda/src/pathOr';
import groupBy from 'ramda/src/groupBy';
import i18n from 'invision-core/src/components/i18n/i18n';
import { fetchCodeTypesThunk } from 'invision-core/src/components/metadata/codes/codes.actions';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import { MetadataCodeLoadedSelector, MetadataOptionsForCodeValuesSelector } from 'invision-core/src/components/metadata/codes/codes.selectors';
import { IsDbss } from 'invision-core/src/components/session/businessunit.selectors';
import { hasAdminAccess } from 'invision-core/src/components/security/permission.service';
import { PageSizePreferenceSelector, UserSecurityAttributesSelector } from 'invision-core/src/components/session/session.selectors';
import LocaleKeys from './../../../../locales/keys';
import { ORDERING_ACCESS } from '../../../../security.attributes';
import { CurrentCustomerIdSelector, CurrentCustomerSelector, IsCurrentCustomerBlocklisted, IsPIIDataAccessEnabledSelector } from '../../../../reducers/selectors/customer.selectors';
import { CurrentPageNumberSelector, CustomerProductsCollectionSelector, IncludeExpiredSelector, IncludeRemovedSelector, IncludeSearchSelector, IsFetchingProductsDataSelector, IsRecentProductsDataSelector, ProductClassificationSelector, RecordCountSelector, SelectedPageSizePreference, SortCriteriaSelector, TableDataSelector, TotalPagesSelector } from '../../../../reducers/selectors/customer.products.selectors';
import { retrieveProducts, setCurrentPage, setIncludedExpiredFilter, setIncludedRemovedFilter, setIncludedSearchFilter, setPageSizePreference, setProductsClassificationType, setSortCriteria } from '../../../../reducers/actions/customer.products.actions';
import { NOTIFICATION_TIME_LENGTH } from '../../../../customercare.constants';
import { isProductEditable } from '../products.component.helpers';
import { DBSS_PRODUCT_DETAILS_PAGE_REDIRECT } from '../../../../reactRoutes';
import { DETAIL_STATE_OR_NAME } from '../products.config';
var MAX_SLOTS_FOR_PAGER = 5;
export var productsListGridSortConstants = {
  column: {
    ProductName: 1,
    OrderDate: 2
  },
  direction: {
    asc: 1,
    desc: 2
  }
};
var CustomerProductsListController = /*#__PURE__*/function () {
  function CustomerProductsListController($ngRedux, $timeout, $interval, uiGridConstants, $scope, uiNotificationService) {
    _classCallCheck(this, CustomerProductsListController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      $timeout: $timeout,
      $interval: $interval,
      uiGridConstants: uiGridConstants,
      $scope: $scope,
      uiNotificationService: uiNotificationService,
      classifications: [],
      CustomerLocaleKeys: LocaleKeys,
      openProductDetailsPage: this.openProductDetailsPage.bind(this),
      selectedItems: [],
      stateOrName: 'index.customercare.customer.products'
    });
  }
  return _createClass(CustomerProductsListController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var columnDefs = [{
        field: 'OrderDate',
        displayName: i18n.translate(LocaleKeys.PRODUCTS_PAGE.CREATED_DATE),
        width: 150,
        enableSorting: true,
        sortDirectionCycle: [this.uiGridConstants.DESC, this.uiGridConstants.ASC],
        cellTemplate: require('./cellTemplates/order.date.html')
      }, {
        field: 'Status',
        displayName: i18n.translate(LocaleKeys.STATUS),
        width: 150,
        cellTemplate: require('./cellTemplates/status.template.html')
      }, {
        field: 'ProductName',
        displayName: i18n.translate(LocaleKeys.PRODUCT),
        minWidth: 150,
        width: '*',
        enableSorting: true,
        sortDirectionCycle: [this.uiGridConstants.ASC, this.uiGridConstants.DESC],
        cellTemplate: require('./cellTemplates/product.name.html')
      }, {
        field: 'Offer',
        displayName: i18n.translate(LocaleKeys.PRODUCTS_PAGE.OFFER),
        maxWidth: 300,
        sortDirectionCycle: [this.uiGridConstants.ASC, this.uiGridConstants.DESC]
      }, {
        field: 'Service',
        displayName: i18n.translate(LocaleKeys.SERVICE),
        maxWidth: 150,
        sortDirectionCycle: [this.uiGridConstants.ASC, this.uiGridConstants.DESC]
      }, {
        field: 'PricingPlan.Name',
        displayName: i18n.translate(LocaleKeys.PRICING_PLAN),
        maxWidth: 350
      }, {
        field: 'Class',
        displayName: i18n.translate(LocaleKeys.PRODUCTS_PAGE.CLASS),
        minWidth: 150,
        sortDirectionCycle: [this.uiGridConstants.ASC, this.uiGridConstants.DESC]
      }];
      var onRegisterApi = function onRegisterApi(event) {
        _this.gridApi = event.grid.api;
        _this.gridApi.selection.on.rowSelectionChanged(null, _this.getSelectedRows.bind(_this));
        _this.gridApi.selection.on.rowSelectionChangedBatch(null, _this.getSelectedRows.bind(_this));
        _this.gridApi.selection.clearSelectedRows();
        var sortCriteria = pathOr({}, ['sortCriteria'], _this.state);
        if (equals(productsListGridSortConstants.column.OrderDate, sortCriteria.SortBy)) {
          _this.state.tableData.columnDefs[0].sort = {
            direction: sortCriteria.SortDirection === productsListGridSortConstants.direction.desc ? _this.uiGridConstants.DESC : _this.uiGridConstants.ASC
          };
        } else if (equals(productsListGridSortConstants.column.ProductName, sortCriteria.SortBy)) {
          _this.state.tableData.columnDefs[2].sort = {
            direction: sortCriteria.SortDirection === productsListGridSortConstants.direction.desc ? _this.uiGridConstants.DESC : _this.uiGridConstants.ASC
          };
        }
        _this.gridApi.core.on.sortChanged(_this.$scope, function (grid, sortColumns) {
          _this.actions.setSortCriteria({
            SortBy: productsListGridSortConstants.column[sortColumns[0].field],
            SortDirection: productsListGridSortConstants.direction[sortColumns[0].sort.direction]
          });
          _this.actions.setCurrentPage(1);
          _this.gridApi.selection.clearSelectedRows();
          _this.fetchProducts();
        });
      };
      var rowTemplate = require('./cellTemplates/row.template.html');
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          codeTypeLoaded: MetadataCodeLoadedSelector(__, store),
          currentCustomer: CurrentCustomerSelector(store),
          currentCustomerId: CurrentCustomerIdSelector(store),
          currentPageNumber: CurrentPageNumberSelector(store),
          data: TableDataSelector(store),
          includeExpired: IncludeExpiredSelector(store),
          includeRemoved: IncludeRemovedSelector(store),
          includeSearch: IncludeSearchSelector(store),
          isCurrentCustomerBlocklisted: IsCurrentCustomerBlocklisted(store),
          isDbss: IsDbss(store),
          isFetchingProductsData: IsFetchingProductsDataSelector(store),
          isPIIDataAccessEnabled: IsPIIDataAccessEnabledSelector(store),
          isRecentProductsOnly: IsRecentProductsDataSelector(store),
          maximumSlots: MAX_SLOTS_FOR_PAGER,
          numberOfPages: TotalPagesSelector(store),
          productClassification: ProductClassificationSelector(store),
          productClassifications: MetadataOptionsForCodeValuesSelector(CODES.ProductClassification, store),
          products: CustomerProductsCollectionSelector(store),
          recordCount: RecordCountSelector(store),
          selectedPageSizePreference: SelectedPageSizePreference(store),
          sortCriteria: SortCriteriaSelector(store),
          tableData: {
            appScopeProvider: _this,
            columnDefs: columnDefs,
            data: TableDataSelector(store),
            enableHorizontalScrollbar: _this.uiGridConstants.scrollbars.NEVER,
            enableSorting: false,
            isRowSelectable: isRowSelectable,
            onRegisterApi: onRegisterApi,
            rowTemplate: rowTemplate,
            useExternalSorting: true
          },
          userPageSizePreference: PageSizePreferenceSelector(store),
          userSecurityAttributes: UserSecurityAttributesSelector(store)
        };
      };
      var isRowSelectable = function isRowSelectable(row) {
        return hasAdminAccess(_this.state.userSecurityAttributes, ORDERING_ACCESS) && isProductEditable(row.entity, _this.state.isDbss);
      };
      var controllerActions = {
        fetchCodeTypes: fetchCodeTypesThunk,
        retrieveProducts: retrieveProducts,
        setCurrentPage: setCurrentPage,
        setIncludedExpiredFilter: setIncludedExpiredFilter,
        setIncludedRemovedFilter: setIncludedRemovedFilter,
        setIncludedSearchFilter: setIncludedSearchFilter,
        setPageSizePreference: setPageSizePreference,
        setProductsClassificationType: setProductsClassificationType,
        setSortCriteria: setSortCriteria,
        stateGo: stateGo
      };
      this.disconnect = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      this.fetchProducts();
      this.model = {
        Classification: this.state.productClassification,
        SearchString: this.state.includeSearch
      };
      this.bulkActionList = [{
        glyph: 'trash',
        name: i18n.translate(this.CustomerLocaleKeys.REMOVE),
        actionFn: function actionFn() {
          _this.openRemoveProductsPopup();
        }
      }];
      if (!this.state.codeTypeLoaded(CODES.ProductClassification)) {
        this.actions.fetchCodeTypes(CODES.ProductClassification).then(function () {
          _this.mapProductClassifications();
        });
      }
      this.mapProductClassifications();
      this.removeProductsPopupConfig = {
        onRegisterApi: function onRegisterApi(_ref) {
          var api = _ref.api;
          _this.removeProductsPopupConfig = api;
        }
      };
      this.multiClassErrorPopup = {
        onRegisterApi: function onRegisterApi(_ref2) {
          var api = _ref2.api;
          _this.multiClassErrorPopup = api;
        }
      };
    }
  }, {
    key: "deselectAll",
    value: function deselectAll() {
      if (this.gridApi) {
        this.gridApi.selection.clearSelectedRows();
      }
      this.selectedItems = [];
    }
  }, {
    key: "disabledNewOrderButtonTooltip",
    get: function get() {
      if (this.state.isCurrentCustomerBlocklisted) {
        return this.CustomerLocaleKeys.CUSTOMER_DASHBOARD.ACCOUNT_STATUS_BLOCKLISTED_LOCKED_ORDERING;
      } else {
        return this.CustomerLocaleKeys.CUSTOMER_DASHBOARD.CONVERGENT_BILLER_ERROR;
      }
    }
  }, {
    key: "getSelectedRows",
    value: function getSelectedRows() {
      this.selectedItems = this.gridApi.selection.getSelectedGridRows().map(function (gridRow) {
        return gridRow.entity;
      });
    }
  }, {
    key: "handleStartNewOrder",
    value: function handleStartNewOrder() {
      if (!this.showDisabledNewOrderButton()) {
        this.actions.stateGo('index.customercare.customer.orders.createProductsOrder', {
          productsOnly: true
        });
      }
    }
  }, {
    key: "handleIncludeExpiredClick",
    value: function handleIncludeExpiredClick() {
      this.actions.setIncludedExpiredFilter(!this.state.includeExpired);
      this.onPageSelected(1);
    }
  }, {
    key: "handleIncludeRemovedClick",
    value: function handleIncludeRemovedClick() {
      this.actions.setIncludedRemovedFilter(!this.state.includeRemoved);
      this.onPageSelected(1);
    }
  }, {
    key: "handleSearchString",
    value: function handleSearchString() {
      this.actions.setIncludedSearchFilter(this.model.SearchString);
      this.onPageSelected(1);
    }
  }, {
    key: "clearSearchText",
    value: function clearSearchText() {
      this.model.SearchString = '';
      this.handleSearchString();
    }
  }, {
    key: "handleClassificationFilter",
    value: function handleClassificationFilter() {
      var _this$model$Classific;
      this.actions.setProductsClassificationType((_this$model$Classific = +this.model.Classification) !== null && _this$model$Classific !== void 0 ? _this$model$Classific : null);
      this.onPageSelected(1);
    }
  }, {
    key: "onPageSelected",
    value: function onPageSelected(page) {
      this.deselectAll();
      this.actions.setCurrentPage(page);
      this.fetchProducts();
    }
  }, {
    key: "onPageSizeOptionSelected",
    value: function onPageSizeOptionSelected(pageSize) {
      this.actions.setPageSizePreference(pageSize);
      this.onPageSelected(1);
    }
  }, {
    key: "hasFiltersApplied",
    value: function hasFiltersApplied() {
      return this.state.includeRemoved || this.state.includeExpired || this.state.includeSearch || !!this.state.productClassification;
    }
  }, {
    key: "fetchProducts",
    value: function fetchProducts() {
      if (!this.state.selectedPageSizePreference) {
        this.actions.setPageSizePreference(this.state.userPageSizePreference);
      }
      var additionalOpts = {
        IncludeExpired: this.state.includeExpired,
        IncludeRemoved: this.state.includeRemoved,
        PageNumber: this.state.currentPageNumber,
        PageSize: this.state.selectedPageSizePreference,
        ProductClassifications: this.state.productClassification,
        SearchString: this.state.includeSearch,
        SortBy: this.state.sortCriteria.SortBy,
        SortDirection: this.state.sortCriteria.SortDirection
      };
      this.actions.retrieveProducts(this.state.currentCustomerId, additionalOpts);
    }
  }, {
    key: "mapProductClassifications",
    value: function mapProductClassifications() {
      this.productClassifications = this.state.productClassifications.map(function (item) {
        if (item.value === null) {
          item.label = i18n.translate(LocaleKeys.ALL);
        }
        return item;
      });
    }
  }, {
    key: "submitRemoveProductsPopup",
    value: function submitRemoveProductsPopup() {
      this.closeRemoveProductsPopup();
      this.deselectAll();
      this.waitForLocker();
    }
  }, {
    key: "waitForLocker",
    value: function waitForLocker() {
      var _this2 = this;
      var productCheckCount = 0;
      this.isLoading = true;
      var orderCompletionInterval = this.$interval(function () {
        _this2.checkLibraryForProducts().then(function (result) {
          if (result) {
            _this2.$interval.cancel(orderCompletionInterval);
            _this2.isLoading = false;
            _this2.fetchProducts();
          }
        });
        if (productCheckCount >= 3) {
          _this2.$interval.cancel(orderCompletionInterval);
          _this2.isLoading = false;
          _this2.fetchProducts();
          _this2.uiNotificationService.info(i18n.translate(_this2.CustomerLocaleKeys.REMOVE_PRODUCTS.LIBRARY_UPDATE), null, {
            timeout: NOTIFICATION_TIME_LENGTH
          });
        } else {
          productCheckCount++;
        }
      }, 2000);
    }
  }, {
    key: "checkLibraryForProducts",
    value: function checkLibraryForProducts() {
      var date = new Date();
      date.setSeconds(date.getSeconds() - 15);
      var additionalOpts = {
        IncludeRemoved: true,
        ModifiedSince: date.toISOString()
      };
      return this.actions.retrieveProducts(this.state.currentCustomerId, additionalOpts).then(function (recentItems) {
        if (recentItems && recentItems.RecordCount > 0) {
          return true;
        }
      });
    }
  }, {
    key: "closeRemoveProductsPopup",
    value: function closeRemoveProductsPopup() {
      this.removeProductsPopupConfig.close();
      this.showRemoveProductsPopup = false;
    }
  }, {
    key: "closeMultiClassErrorPopup",
    value: function closeMultiClassErrorPopup() {
      this.multiClassErrorPopup.close();
    }
  }, {
    key: "openRemoveProductsPopup",
    value: function openRemoveProductsPopup() {
      var groupedByProductClassification = groupBy(function (item) {
        return item.Product.ProductClassification;
      }, this.selectedItems);
      if (Object.keys(groupedByProductClassification).length === 1) {
        // 1 being they are all the same type of classification
        this.showRemoveProductsPopup = true;
        this.$timeout(this.removeProductsPopupConfig.open);
      } else {
        this.$timeout(this.multiClassErrorPopup.open);
      }
    }
  }, {
    key: "openProductDetailsPage",
    value: function openProductDetailsPage(subscriberProductId) {
      if (this.state.isDbss) {
        this.actions.stateGo(DBSS_PRODUCT_DETAILS_PAGE_REDIRECT, {
          customerId: this.state.currentCustomerId,
          subscriberProductId: subscriberProductId
        });
      } else {
        this.actions.stateGo(DETAIL_STATE_OR_NAME, {
          lockerItemId: subscriberProductId
        });
      }
    }
  }, {
    key: "hasOrderingAccess",
    value: function hasOrderingAccess() {
      return hasAdminAccess(this.state.userSecurityAttributes, ORDERING_ACCESS) && this.state.isPIIDataAccessEnabled;
    }
  }, {
    key: "showDisabledNewOrderButton",
    value: function showDisabledNewOrderButton() {
      return this.state.isDbss && !this.state.currentCustomer.ConvergentBillerId || this.state.isCurrentCustomerBlocklisted;
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnect();
    }
  }]);
}();
export default {
  template: require('./products.list.html'),
  controller: CustomerProductsListController,
  controllerAs: 'CustomerProductsList'
};